angular.module('dnecom')
    .filter('timerState', ["timerRemainingFilter", function(timerRemainingFilter) {

        return function(timer, timezone) {

            if (timer.timer_type == "none") {
                return 'No timer';
            }
            else if (timer.timer_type == "global") {
                return  timerRemainingFilter(timer, timezone) == 'Expired' ? 'Expired' : '';
            }
            else if (timer.timer_type == "personalized") {
                return  (timer.timer_duration.days == 0 && timer.timer_duration.hours == 0 && timer.timer_duration.minutes == 0) ? 'Unspecified' : 'Personalized';
            }
            else {
                return '';
            }

        };
    }]);
